function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { defineComponent, computed, ref } from "vue";
import AuthorizationForm from "./authorization-form.vue";
import { definePropType } from "@types-vue/props";
export default defineComponent({
    props: {
        visible: {
            type: definePropType(Boolean),
            default: false,
            required: true
        },
        action: {
            type: definePropType(String),
            default: "create"
        },
        formItemInfo: {
            type: definePropType(Object),
            default: function() {
                return {};
            }
        }
    },
    components: {
        AuthorizationForm: AuthorizationForm
    },
    setup: function setup(props, param) {
        var emit = param.emit, attrs = param.attrs;
        var authorizationFormRef = ref();
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                var _$ref;
                (_$ref = authorizationFormRef.value) === null || _$ref === void 0 ? void 0 : _$ref.cancel();
                emit("update:visible", val);
            }
        });
        var dialogAttrs = computed(function() {
            return _objectSpread({
                title: props.action === "update" ? "\u7F16\u8F91\u6388\u6743\u4FE1\u606F" : "\u65B0\u589E\u6388\u6743"
            }, attrs);
        });
        var closeDialog = function() {
            emit("update:visible", false);
        };
        var updateAuthorizationList = function() {
            emit("save-form");
        };
        return {
            dialogVisible: dialogVisible,
            dialogAttrs: dialogAttrs,
            closeDialog: closeDialog,
            updateAuthorizationList: updateAuthorizationList,
            authorizationFormRef: authorizationFormRef
        };
    }
});
